import { render, staticRenderFns } from "./InternetSection.vue?vue&type=template&id=f0b0e49a"
import script from "./InternetSection.vue?vue&type=script&lang=ts"
export * from "./InternetSection.vue?vue&type=script&lang=ts"
import style0 from "./InternetSection.vue?vue&type=style&index=0&id=f0b0e49a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports